<div class="container-box">
  <app-table-header tableTitle="Agenzie noleggio" (btnUpdateClick)="loadRentalAgency()">
    <app-button-new-rental-agency action-button></app-button-new-rental-agency>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="rentalAgencyTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
